'use client'

import React, { useState } from 'react'
import { QuestionCircleIcon } from '@/components/icons/QuestionCircleIcon'
import { ContactFormModal } from '@/components/ContactFormModal.lazy'

type Props = {
  text?: string
  className?: string
  iconClassName?: string
  textClassName?: string
  showIcon?: boolean
}

export function SidebarCTAModal({
  text = 'Ask Us About Your Remodel',
  className,
  iconClassName,
  textClassName,
  showIcon = true,
}: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`flex w-full items-center justify-center gap-2 text-center text-[18px] font-bold text-black transition-colors hover:text-[#1595a7]  ${className ?? ''}`}
      >
        {showIcon && (
          <QuestionCircleIcon aria-hidden className={`h-5 w-5 shrink-0 ${iconClassName ?? ''}`} />
        )}
        <span className={textClassName}>{text}</span>
      </button>

      <ContactFormModal onClose={() => setOpen(false)} open={open} />
    </>
  )
}
